import { useEffect, useState } from "react";
import { ActionButton } from "../../../components/Forms/ActionButton";
import Question from "./Question";
import InputField from "../../../components/Forms/InputField";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";

const SubmissionInformation = ({
    navigate, active,
    allowEarlySubmission, setAllowEarlySubmission,
    allowLateSubmission, setAllowLateSubmission,
    questions, setQuestions,
    handleSubmissionInformationSubmit,
    pages, setPages,
    handleChallengeInformationChange, totalPoints,
    calculateTotalPoints, setSelectedTab,
    errors, setErrors, submissionButtonType,
    setSubmissionButtonType, submissionProvision,
    setSubmissionProvision, updateQuestion,
    bonusPage, setBonusPage,
    handleSaveDraft,
}) => {

    const [localErrors, setLocalErrors] = useState([]);
    const [expandedPageIndex, setExpandedPageIndex] = useState(0);
    const [expandedQuestionIndex, setExpandedQuestionIndex] = useState({ 0: 0 });
    const [addPageNumber, setAddPageNumber] = useState('');

    const addPage = () => {
        setPages([...pages, {
            title: '',
            isBonusPage: false,
            questions: [
                {
                    questionType: "description",
                    correctDate: "",
                    dropdownValues: [],
                    verificationRequired: true,
                    submissionRequired: true,
                    verificationType: "manual",
                    question: "",
                    answerLimit: "500",
                    mcqOptions: [],
                    title: "",
                    mediaType: "image",
                    maxMediaUploadCount: "1",
                    maxMediaUploadSize: "",
                    selfImageRequired: false,
                    sampleMedia: "",
                    stateSampleMedia: null,
                    description: "",
                    sponsored: false,
                    selfImageNotPresentPenaltyPoints: "",
                    withoutSelfImagePoints: "",
                    videoSubmissionPoints: "",
                    points: '',
                    bonusPoints: 0,
                    image: null,
                    isImagePresent: false,
                }
            ],
        }]);
        setExpandedPageIndex(pages.length);
        setExpandedQuestionIndex({ ...expandedQuestionIndex, [pages.length]: 0 });
        localErrors.length > 0 && setLocalErrors([]);
    }

    const addBonusPage = () => {
        setPages([...pages, {
            title: 'Bonus Section',
            isBonusPage: true,
            questions: [
                {
                    questionType: "description",
                    correctDate: "",
                    dropdownValues: [],
                    verificationRequired: true,
                    submissionRequired: false,
                    verificationType: "manual",
                    question: "",
                    answerLimit: "500",
                    mcqOptions: [],
                    title: "",
                    mediaType: "image",
                    maxMediaUploadCount: "1",
                    maxMediaUploadSize: "",
                    selfImageRequired: false,
                    sampleMedia: "",
                    stateSampleMedia: null,
                    description: "",
                    sponsored: false,
                    selfImageNotPresentPenaltyPoints: "",
                    withoutSelfImagePoints: "",
                    videoSubmissionPoints: "",
                    points: '',
                    bonusPoints: 0,
                    image: null,
                    isImagePresent: false,
                }
            ],
        }]);
        setExpandedPageIndex(pages.length);
        setExpandedQuestionIndex({ ...expandedQuestionIndex, [pages.length]: 0 });
    }

    const updatePageName = (index, name) => {
        const updatedPages = [...pages];
        updatedPages[index].title = name;
        setPages(updatedPages);
    };

    const addQuestionToPage = (pageIndex) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions.push({
            questionType: "description",
            correctDate: "",
            dropdownValues: [],
            verificationRequired: true,
            submissionRequired: pages[pageIndex].isBonusPage ? false : true,
            verificationType: "manual",
            question: "",
            answerLimit: "500",
            mcqOptions: [],
            title: "",
            mediaType: "image",
            maxMediaUploadCount: "1",
            maxMediaUploadSize: "",
            selfImageRequired: false,
            sampleMedia: "",
            stateSampleMedia: null,
            description: "",
            sponsored: false,
            selfImageNotPresentPenaltyPoints: "",
            withoutSelfImagePoints: "",
            videoSubmissionPoints: "",
            points: '',
            bonusPoints: 0,
            image: null,
            isImagePresent: false,
        });
        setPages(updatedPages);
        setExpandedQuestionIndex({ ...expandedQuestionIndex, [pageIndex]: updatedPages[pageIndex].questions.length - 1 });
    };

    // const updateQuestion = (pageIndex, questionIndex, updatedQuestion) => {
    //     const updatedPages = [...pages];
    //     updatedPages[pageIndex].questions[questionIndex] = updatedQuestion;
    //     setPages(updatedPages);
    // };

    const removeQuestionFromPage = (pageIndex, questionIndex) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions.splice(questionIndex, 1);
        setPages(updatedPages);
        calculateTotalPoints();
    };

    const removePage = (pageIndex) => {
        const updatedPages = [...pages];
        updatedPages.splice(pageIndex, 1);
        setPages(updatedPages);
        calculateTotalPoints();
    };

    const validatePagesAndQuestions = () => {
        const errors = [];
        if (pages.length === 0) {
            errors.push({ pageErr: true, message: "Add at least one page" });
        } else {
            pages.forEach((page, pageIndex) => {
                if (page.questions.length === 0) {
                    errors.push({ pageErr: true, message: `Add at least one question in Page ${pageIndex + 1}` });
                } else {
                    page.questions.forEach((question, questionIndex) => {
                        if (!question.questionType) {
                            errors.push({ questionErr: true, pageIndex, questionIndex, field: 'questionType', message: `Question Type is required in Page ${pageIndex + 1}, Question ${questionIndex + 1}` });
                            setExpandedPageIndex(pageIndex);
                            setExpandedQuestionIndex({ ...expandedQuestionIndex, [pageIndex]: questionIndex });
                            document.querySelector(`[data-page-index="${pageIndex}"][data-question-index="${questionIndex}"][data-field="questionType"]`)?.focus();
                        }
                        if (!question.verificationType) {
                            errors.push({ questionErr: true, pageIndex, questionIndex, field: 'verificationType', message: `Verification Type is required in Page ${pageIndex + 1}, Question ${questionIndex + 1}` });
                            setExpandedPageIndex(pageIndex);
                            setExpandedQuestionIndex({ ...expandedQuestionIndex, [pageIndex]: questionIndex });
                            document.querySelector(`[data-page-index="${pageIndex}"][data-question-index="${questionIndex}"][data-field="verificationType"]`)?.focus();
                        }
                        if (!question.verificationRequired) {
                            errors.push({ questionErr: true, pageIndex, questionIndex, field: 'verificationRequired', message: `Verification Required is required in Page ${pageIndex + 1}, Question ${questionIndex + 1}` });
                            setExpandedPageIndex(pageIndex);
                            setExpandedQuestionIndex({ ...expandedQuestionIndex, [pageIndex]: questionIndex });
                            document.querySelector(`[data-page-index="${pageIndex}"][data-question-index="${questionIndex}"][data-field="verificationRequired"]`)?.focus();
                        }
                        if (!question.points) {
                            errors.push({ questionErr: true, pageIndex, questionIndex, field: 'points', message: `Points are required in Page ${pageIndex + 1}, Question ${questionIndex + 1}` });
                            setExpandedPageIndex(pageIndex);
                            setExpandedQuestionIndex({ ...expandedQuestionIndex, [pageIndex]: questionIndex });
                            document.querySelector(`[data-page-index="${pageIndex}"][data-question-index="${questionIndex}"][data-field="points"]`)?.focus();
                        }
                    });
                }
            });
        }
        // console.log(errors);
        return errors;
    };

    const handleNext = (e) => {
        e.preventDefault();
        if (active) {
            const validationErrors = validatePagesAndQuestions();
            setLocalErrors(validationErrors);
            if (validationErrors.length > 0) {
                return;
            }
            setSelectedTab('products/services');
            // setSelectedTab('App Display Configuration');
        }
        else {
            setSelectedTab('products/services');
            // setSelectedTab('App Display Configuration');
        }
    }

    useEffect(() => {
        setErrors(localErrors);
    }, [localErrors]);

    const togglePage = (index) => {
        setExpandedPageIndex(expandedPageIndex === index ? null : index);
    }

    const toggleQuestion = (pageIndex, questionIndex) => {
        setExpandedQuestionIndex(prevState => ({
            ...prevState,
            [pageIndex]: prevState[pageIndex] === questionIndex ? null : questionIndex
        }));
    }

    const handleAddPage = () => {
        const updatedPages = [...pages];
        for (let i = 0; i < addPageNumber; i++) {
            updatedPages.push({
                title: '',
                isBonusPage: false,
                questions: [
                    {
                        questionType: "description",
                        correctDate: "",
                        dropdownValues: [],
                        verificationRequired: true,
                        submissionRequired: true,
                        verificationType: "manual",
                        question: "",
                        answerLimit: "500",
                        mcqOptions: [],
                        title: "",
                        mediaType: "image",
                        maxMediaUploadCount: "1",
                        maxMediaUploadSize: "",
                        selfImageRequired: false,
                        sampleMedia: "",
                        stateSampleMedia: null,
                        description: "",
                        sponsored: false,
                        selfImageNotPresentPenaltyPoints: "",
                        withoutSelfImagePoints: "",
                        videoSubmissionPoints: "",
                        points: '',
                        bonusPoints: 0,
                        image: null,
                        isImagePresent: false,
                    }
                ],
            });
        }
        setPages(updatedPages);
        setAddPageNumber('');
    }

    // useEffect(() => {
    //     setPages(prevPages =>
    //         prevPages.map(page => ({
    //             ...page,
    //             questions: page.questions.map(question => ({
    //                 ...question,
    //                 maxMediaUploadSize: question.questionType === "media" && question.mediaType === "video" ? "50" : "10",
    //                 points: question.questionType === "media" && question.mediaType === "video" ? "200" : "100",
    //                 setselfImageNotPresentPenaltyPoints: question.questionType === "media" && question.mediaType === "video" ? "100" : "50",
    //             })),
    //         }))
    //     );
    // }, []);

    const submissionRequiredHandler = (pageindex, questionindex) => {
        const updatedPages = [...pages];
        updatedPages[pageindex].questions[questionindex].submissionRequired = !updatedPages[pageindex].questions[questionindex].submissionRequired;
        setPages(updatedPages);
    }

    const handlePointsChange = (pageIndex, questionIndex, value) => {
        calculateTotalPoints();
    }

    const setQuestionType = (pageIndex, questionIndex, value) => {
        const updatedQuestion = {...pages[pageIndex].questions[questionIndex]};
        updatedQuestion.questionType = value;
        
        // Use updateQuestion to handle default points logic
        updateQuestion(pageIndex, questionIndex, updatedQuestion);
        calculateTotalPoints();
    }

    const setCorrectDate = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].correctDate = value;
        setPages(updatedPages);
    }

    const setDropdownValues = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].dropdownValues = value;
        setPages(updatedPages);
    }

    const setVerificationRequired = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].verificationRequired = value;
        setPages(updatedPages);
    }

    const setSubmissionRequired = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].submissionRequired = value;
        setPages(updatedPages);
    }

    const setVerificationType = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].verificationType = value;
        setPages(updatedPages);
    }

    const setQuestion = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].question = value;
        setPages(updatedPages);
    }

    const setAnswerLimit = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].answerLimit = value;
        setPages(updatedPages);
    }

    const setMcqOptions = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].mcqOptions = value;
        setPages(updatedPages);
    }

    const setTitle = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].title = value;
        setPages(updatedPages);
    }

    const setMediaType = (pageIndex, questionIndex, value) => {
        const updatedQuestion = {...pages[pageIndex].questions[questionIndex]};
        updatedQuestion.mediaType = value;
        
        // Set default points based on media type if they were using default points before
        // or if points aren't set yet
        if (!updatedQuestion.points || updatedQuestion.isDefaultPoints === true) {
            updatedQuestion.points = value === 'video' ? '200' : '100';
            updatedQuestion.isDefaultPoints = true;
        }
        
        // This will trigger the updateQuestion logic in CreateChallenge.jsx
        updateQuestion(pageIndex, questionIndex, updatedQuestion);
        calculateTotalPoints();
    }

    const setMaxMediaUploadCount = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].maxMediaUploadCount = value;
        setPages(updatedPages);
    }

    const setMaxMediaUploadSize = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].maxMediaUploadSize = value;
        setPages(updatedPages);
    }

    const setSelfImageRequired = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].selfImageRequired = value;
        setPages(updatedPages);
    }

    const setDescription = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].description = value;
        setPages(updatedPages);
    }

    const setSponsored = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].sponsored = value;
        setPages(updatedPages);
    }

    const setselfImageNotPresentPenaltyPoints = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].selfImageNotPresentPenaltyPoints = value;
        setPages(updatedPages);
    }

    const setWithoutSelfImagePoints = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].withoutSelfImagePoints = value;
        setPages(updatedPages);
    }

    const setVideoSubmissionPoints = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].videoSubmissionPoints = value;
        setPages(updatedPages);
    }

    const setPoints = (pageIndex, questionIndex, value) => {
        const updatedQuestion = {...pages[pageIndex].questions[questionIndex]};
        updatedQuestion.points = value;
        updatedQuestion.isDefaultPoints = false; // User manually set the points
        
        // Use updateQuestion to handle the update while preserving flags
        updateQuestion(pageIndex, questionIndex, updatedQuestion);
        calculateTotalPoints();
    }

    const setBonusPoints = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].bonusPoints = value;
        setPages(updatedPages);
    }

    const setCorrectMCQAnswer = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].correctMCQAnswer = value;
        setPages(updatedPages);
    }

    const setSampleMedia = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].sampleMedia = value;
        setPages(updatedPages);
    };

    const setStateSampleMedia = (pageIndex, questionIndex, value) => {
        const updatedPages = [...pages];
        updatedPages[pageIndex].questions[questionIndex].stateSampleMedia = value;
        setPages(updatedPages);
    };

    return (
        <form className='mt-7'>
            {/* <div className="flex gap-2">
                <InputField
                    label={'Submission Provision'}
                    name={'submissionProvision'}
                    type={'select'}
                    placeholder={'Select Submission Provision'}
                    data={[
                        { placeholder: 'Allow Early Submission', value: 'allowEarlySubmission' },
                        { placeholder: 'Allow Late Submission', value: 'allowLateSubmission' }
                    ]}
                    value={submissionProvision}
                    onChange={(e) => setSubmissionProvision(e.target.value)}
                />
                <InputField
                    label={'Submission Button Type'}
                    name={'submissionButtonType'}
                    type={'select'}
                    placeholder={'Select Submission Button Type'}
                    data={[
                        { placeholder: 'Display Submission Button Page Wise', value: 'page' },
                        { placeholder: 'Display Submission Button At The End', value: 'end' }
                    ]}
                    value={submissionButtonType}
                    onChange={(e) => setSubmissionButtonType(e.target.value)}
                />
            </div> */}

            {/* {pages.length === 0 &&
                <div className="place-self-end mt-5">
                    <ActionButton variant={'reset'} text={'+ Add New Page'} handleSubmit={addPage} />
                    {localErrors.length > 0 && localErrors[0].pageErr && <div className="text-red text-sm font-bold">{localErrors[0].message}</div>}
                </div>
            } */}

            <div className="flex justify-between items-center">
                <div className="my-auto text-lg font-semibold mb-2 mt-7">Submission Pages</div>
                {/* <div className="my-auto text-base font-semibold flex justify-between items-center">Add Pages</div> */}
                <div className="flex gap-2">
                    <input
                        type="number"
                        value={addPageNumber}
                        onChange={(e) => setAddPageNumber(e.target.value)}
                        placeholder="Enter Page No. to Add"
                        className="border border-navBtn rounded px-2 py-2 outline-none basis-1/3 text-base"
                    />
                    <ActionButton
                        variant={'reset'}
                        text={'Add Page'}
                        handleSubmit={handleAddPage}
                    />
                </div>
            </div>
            <div className="mt-2 border border-border px-2 rounded-md">
                {pages.map((page, pageIndex) => (
                    <div key={pageIndex} className="my-2 p-2 border border-border">
                        <div className="flex justify-between items-center cursor-pointer" onClick={() => togglePage(pageIndex)}>
                            <div className="flex items-center gap-3">
                                <h1 className="flex items-center justify-center">{expandedPageIndex === pageIndex ? <FaAngleDown /> : <FaAngleRight />}{`Page-${pageIndex + 1}`}</h1>
                                <input
                                    type="text"
                                    value={page.title}
                                    onChange={(e) => updatePageName(pageIndex, e.target.value)}
                                    placeholder="Enter Page Name"
                                    onClick={(e) => e.stopPropagation()}
                                    className="border border-navBtn rounded px-2 py-2 outline-none basis-1/3"
                                />
                                <div className="my-auto text-base font-semibold flex justify-between items-center">(Questions Added: {pages[pageIndex].questions.length})</div>
                            </div>
                            <div className="items-center flex gap-5">
                                <p className='text-base'>Page {pageIndex + 1} Points: <span className='font-bold text-primary'>{/*Sum of points of all questoins of this page*/
                                    pages[pageIndex].questions.reduce((total, question) => total + parseInt(question.points), 0)
                                    || 0
                                }
                                </span></p>

                                <ActionButton variant={'white'} className="flex gap-2.5 items-center px-5 py-2 text-base text-center rounded-md bg-white hover:bg-border" text={'Remove Page ' + (pageIndex + 1)} handleSubmit={() => removePage(pageIndex)} />

                            </div>
                        </div>

                        {expandedPageIndex === pageIndex && (
                            <>
                                {page.questions.map((question, questionIndex) => {
                                    const questionErrors = localErrors.filter(error => error.pageIndex === pageIndex && error.questionIndex === questionIndex);
                                    return (
                                        <div key={questionIndex} className="border border-navBtn rounded p-3 mt-2 flex flex-col w-full">
                                            <div className="flex justify-between items-center">
                                                <div className="rounded-md cursor-pointer flex justify-between items-center" onClick={() => toggleQuestion(pageIndex, questionIndex)}>
                                                    <h1 className='flex items-center justify-center'>{expandedQuestionIndex[expandedPageIndex] === questionIndex ? <FaAngleDown /> : <FaAngleRight />}{`Question-${questionIndex + 1} `} </h1>
                                                    {/* <input
                                                        type={'number'}
                                                        value={question.points}
                                                        placeholder="Enter Points"
                                                        className="border border-navBtn rounded px-2 py-2 outline-none basis-1/3"
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => handlePointsChange(pageIndex,questionIndex, e.target.value)}
                                                        required={true}
                                                    /> */}
                                                </div>
                                                <div className='flex gap-2'>
                                                    <input type="checkbox" id="submission-required" name="submissionRequired" onChange={() => submissionRequiredHandler(pageIndex, questionIndex)} checked={question.submissionRequired} />
                                                    <span>Submission Required</span>
                                                </div>
                                                <ActionButton
                                                    variant={'white'}
                                                    text={'Remove Question ' + (questionIndex + 1) + ' from Page ' + (pageIndex + 1)}
                                                    className="flex gap-2.5 items-center px-5  text-base text-center rounded-md bg-white hover:bg-border"
                                                    handleSubmit={() => removeQuestionFromPage(pageIndex, questionIndex)}
                                                />
                                            </div>
                                            {expandedQuestionIndex[pageIndex] === questionIndex && (
                                                <div className="flex justify-between items-center">
                                                    <Question
                                                        active={active}
                                                        questionType={question.questionType}
                                                        setQuestionType={value => {
                                                            setQuestionType(pageIndex, questionIndex, value);
                                                        }}
                                                        correctDate={question.correctDate}
                                                        setCorrectDate={value => {
                                                            setCorrectDate(pageIndex, questionIndex, value);
                                                        }}
                                                        dropdownValues={question.dropdownValues}
                                                        setDropdownValues={value => {
                                                            setDropdownValues(pageIndex, questionIndex, value);
                                                        }}
                                                        verificationRequired={question.verificationRequired}
                                                        setVerificationRequired={value => {
                                                            setVerificationRequired(pageIndex, questionIndex, value);
                                                        }}
                                                        submissionRequired={question.submissionRequired}
                                                        setSubmissionRequired={value => {
                                                            setSubmissionRequired(pageIndex, questionIndex, value);
                                                        }}
                                                        verificationType={question.verificationType}
                                                        setVerificationType={value => {
                                                            setVerificationType(pageIndex, questionIndex, value);
                                                        }}
                                                        question={question.question}
                                                        setQuestion={value => {
                                                            setQuestion(pageIndex, questionIndex, value);
                                                        }}
                                                        answerLimit={question.answerLimit}
                                                        setAnswerLimit={value => {
                                                            setAnswerLimit(pageIndex, questionIndex, value);
                                                        }}
                                                        mcqOptions={question.mcqOptions}
                                                        setMcqOptions={value => {
                                                            setMcqOptions(pageIndex, questionIndex, value);
                                                        }}
                                                        title={question.title}
                                                        setTitle={value => {
                                                            setTitle(pageIndex, questionIndex, value);
                                                        }}
                                                        mediaType={question.mediaType}
                                                        setMediaType={value => {
                                                            setMediaType(pageIndex, questionIndex, value);
                                                        }}
                                                        maxMediaUploadCount={question.maxMediaUploadCount}
                                                        setMaxMediaUploadCount={value => {
                                                            setMaxMediaUploadCount(pageIndex, questionIndex, value);
                                                        }}
                                                        maxMediaUploadSize={question.maxMediaUploadSize}
                                                        setMaxMediaUploadSize={value => {
                                                            setMaxMediaUploadSize(pageIndex, questionIndex, value);
                                                        }}
                                                        selfImageRequired={question.selfImageRequired}
                                                        setSelfImageRequired={value => {
                                                            setSelfImageRequired(pageIndex, questionIndex, value);
                                                        }}
                                                        description={question.description}
                                                        setDescription={value => {
                                                            setDescription(pageIndex, questionIndex, value);
                                                        }}
                                                        sponsored={question.sponsored}
                                                        setSponsored={value => {
                                                            setSponsored(pageIndex, questionIndex, value);
                                                        }}
                                                        selfImageNotPresentPenaltyPoints={question.selfImageNotPresentPenaltyPoints}
                                                        setselfImageNotPresentPenaltyPoints={value => {
                                                            setselfImageNotPresentPenaltyPoints(pageIndex, questionIndex, value);
                                                        }}
                                                        withoutSelfImagePoints={question.withoutSelfImagePoints}
                                                        setWithoutSelfImagePoints={value => {
                                                            setWithoutSelfImagePoints(pageIndex, questionIndex, value);
                                                        }}
                                                        videoSubmissionPoints={question.videoSubmissionPoints}
                                                        setVideoSubmissionPoints={value => {
                                                            setVideoSubmissionPoints(pageIndex, questionIndex, value);
                                                        }}
                                                        points={question.points}
                                                        setPoints={value => {
                                                            setPoints(pageIndex, questionIndex, value);
                                                        }}
                                                        bonusPoints={question.bonusPoints}
                                                        setBonusPoints={value => {
                                                            setBonusPoints(pageIndex, questionIndex, value);
                                                        }}
                                                        correcMCQAnswer={question.correcMCQAnswer}
                                                        setCorrectMCQAnswer={value => {
                                                            setCorrectMCQAnswer(pageIndex, questionIndex, value);
                                                        }}
                                                        sampleMedia={question.sampleMedia}
                                                        setSampleMedia={value => {
                                                            setSampleMedia(pageIndex, questionIndex, value);
                                                        }}
                                                        setStateSampleMedia={value => {
                                                            setStateSampleMedia(pageIndex, questionIndex, value);
                                                        }}
                                                        calculateTotalPoints={calculateTotalPoints}
                                                    />
                                                </div>
                                            )}
                                            <div className="flex my-2 justify-end">
                                                {
                                                    questionErrors.length > 0 && questionErrors[0].questionErr && <div className="text-red text-sm font-bold">{questionErrors[0].message}</div>
                                                }
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="flex my-2 justify-end">
                                    <ActionButton variant={'reset'} text={'+ Add Question'} handleSubmit={() => addQuestionToPage(pageIndex)} />
                                </div>
                            </>
                        )}
                    </div>
                ))}
                {
                    bonusPage.map((page, pageIndex) => (
                        <div key={pageIndex} className="my-2 p-2 border border-border">
                            <div className="flex justify-between items-center cursor-pointer" onClick={() => togglePage(pageIndex)}>
                                <div className="flex items-center gap-3">
                                    <h1 className="flex items-center justify-center">{expandedPageIndex === pageIndex ? <FaAngleDown /> : <FaAngleRight />}{`Page-${pageIndex + 1}`}</h1>
                                    <input
                                        type="text"
                                        value={page.title}
                                        onChange={(e) => updatePageName(pageIndex, e.target.value)}
                                        placeholder="Enter Page Name"
                                        onClick={(e) => e.stopPropagation()}
                                        className="border border-navBtn rounded px-2 py-2 outline-none basis-1/3"
                                    />
                                    <div className="my-auto text-base font-semibold flex justify-between items-center">(Questions Added: {pages[pageIndex].questions.length})</div>
                                </div>
                                <div className="items-center flex gap-5">
                                    <p className='text-base'>Page {pageIndex + 1} Points: <span className='font-bold text-primary'>{/*Sum of points of all questoins of this page*/
                                        pages[pageIndex].questions.reduce((total, question) => total + parseInt(question.points), 0)
                                        || 0
                                    }
                                    </span></p>

                                    <ActionButton variant={'white'} className="flex gap-2.5 items-center px-5 py-2 text-base text-center rounded-md bg-white hover:bg-border" text={'Remove Page ' + (pageIndex + 1)} handleSubmit={() => removePage(pageIndex)} />

                                </div>
                            </div>

                            {expandedPageIndex === pageIndex && (
                                <>
                                    {page.questions.map((question, questionIndex) => {
                                        const questionErrors = localErrors.filter(error => error.pageIndex === pageIndex && error.questionIndex === questionIndex);
                                        return (
                                            <div key={questionIndex} className="border border-navBtn rounded p-3 mt-2 flex flex-col w-full">
                                                <div className="flex justify-between items-center">
                                                    <div className="rounded-md cursor-pointer flex justify-between items-center" onClick={() => toggleQuestion(pageIndex, questionIndex)}>
                                                        <h1 className='flex items-center justify-center'>{expandedQuestionIndex[expandedPageIndex] === questionIndex ? <FaAngleDown /> : <FaAngleRight />}{`Question-${questionIndex + 1} `} </h1>
                                                        {/* <input
                                                        type={'number'}
                                                        value={question.points}
                                                        placeholder="Enter Points"
                                                        className="border border-navBtn rounded px-2 py-2 outline-none basis-1/3"
                                                        onClick={(e) => e.stopPropagation()}
                                                        onChange={(e) => handlePointsChange(pageIndex,questionIndex, e.target.value)}
                                                        required={true}
                                                    /> */}
                                                    </div>
                                                    <div className='flex gap-2'>
                                                        <input type="checkbox" id="submission-required" name="submissionRequired" onChange={() => submissionRequiredHandler(pageIndex, questionIndex)} checked={question.submissionRequired} />
                                                        <span>Submission Required</span>
                                                    </div>
                                                    <ActionButton
                                                        variant={'white'}
                                                        text={'Remove Question ' + (questionIndex + 1) + ' from Page ' + (pageIndex + 1)}
                                                        className="flex gap-2.5 items-center px-5  text-base text-center rounded-md bg-white hover:bg-border"
                                                        handleSubmit={() => removeQuestionFromPage(pageIndex, questionIndex)}
                                                    />
                                                </div>
                                                {expandedQuestionIndex[pageIndex] === questionIndex && (
                                                    <div className="flex justify-between items-center">
                                                        <Question
                                                            active={active}
                                                            questionType={question.questionType}
                                                            setQuestionType={value => {
                                                                setQuestionType(pageIndex, questionIndex, value);
                                                            }}
                                                            correctDate={question.correctDate}
                                                            setCorrectDate={value => {
                                                                setCorrectDate(pageIndex, questionIndex, value);
                                                            }}
                                                            dropdownValues={question.dropdownValues}
                                                            setDropdownValues={value => {
                                                                setDropdownValues(pageIndex, questionIndex, value);
                                                            }}
                                                            verificationRequired={question.verificationRequired}
                                                            setVerificationRequired={value => {
                                                                setVerificationRequired(pageIndex, questionIndex, value);
                                                            }}
                                                            submissionRequired={question.submissionRequired}
                                                            setSubmissionRequired={value => {
                                                                setSubmissionRequired(pageIndex, questionIndex, value);
                                                            }}
                                                            verificationType={question.verificationType}
                                                            setVerificationType={value => {
                                                                setVerificationType(pageIndex, questionIndex, value);
                                                            }}
                                                            question={question.question}
                                                            setQuestion={value => {
                                                                setQuestion(pageIndex, questionIndex, value);
                                                            }}
                                                            answerLimit={question.answerLimit}
                                                            setAnswerLimit={value => {
                                                                setAnswerLimit(pageIndex, questionIndex, value);
                                                            }}
                                                            mcqOptions={question.mcqOptions}
                                                            setMcqOptions={value => {
                                                                setMcqOptions(pageIndex, questionIndex, value);
                                                            }}
                                                            title={question.title}
                                                            setTitle={value => {
                                                                setTitle(pageIndex, questionIndex, value);
                                                            }}
                                                            mediaType={question.mediaType}
                                                            setMediaType={value => {
                                                                setMediaType(pageIndex, questionIndex, value);
                                                            }}
                                                            maxMediaUploadCount={question.maxMediaUploadCount}
                                                            setMaxMediaUploadCount={value => {
                                                                setMaxMediaUploadCount(pageIndex, questionIndex, value);
                                                            }}
                                                            maxMediaUploadSize={question.maxMediaUploadSize}
                                                            setMaxMediaUploadSize={value => {
                                                                setMaxMediaUploadSize(pageIndex, questionIndex, value);
                                                            }}
                                                            selfImageRequired={question.selfImageRequired}
                                                            setSelfImageRequired={value => {
                                                                setSelfImageRequired(pageIndex, questionIndex, value);
                                                            }}
                                                            description={question.description}
                                                            setDescription={value => {
                                                                setDescription(pageIndex, questionIndex, value);
                                                            }}
                                                            sponsored={question.sponsored}
                                                            setSponsored={value => {
                                                                setSponsored(pageIndex, questionIndex, value);
                                                            }}
                                                            selfImageNotPresentPenaltyPoints={question.selfImageNotPresentPenaltyPoints}
                                                            setselfImageNotPresentPenaltyPoints={value => {
                                                                setselfImageNotPresentPenaltyPoints(pageIndex, questionIndex, value);
                                                            }}
                                                            withoutSelfImagePoints={question.withoutSelfImagePoints}
                                                            setWithoutSelfImagePoints={value => {
                                                                setWithoutSelfImagePoints(pageIndex, questionIndex, value);
                                                            }}
                                                            videoSubmissionPoints={question.videoSubmissionPoints}
                                                            setVideoSubmissionPoints={value => {
                                                                setVideoSubmissionPoints(pageIndex, questionIndex, value);
                                                            }}
                                                            points={question.points}
                                                            setPoints={value => {
                                                                setPoints(pageIndex, questionIndex, value);
                                                            }}
                                                            bonusPoints={question.bonusPoints}
                                                            setBonusPoints={value => {
                                                                setBonusPoints(pageIndex, questionIndex, value);
                                                            }}
                                                            correcMCQAnswer={question.correcMCQAnswer}
                                                            setCorrectMCQAnswer={value => {
                                                                setCorrectMCQAnswer(pageIndex, questionIndex, value);
                                                            }}
                                                            sampleMedia={question.sampleMedia}
                                                            setSampleMedia={value => {
                                                                setSampleMedia(pageIndex, questionIndex, value);
                                                            }}
                                                            setStateSampleMedia={value => {
                                                                setStateSampleMedia(pageIndex, questionIndex, value);
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <div className="flex my-2 justify-end">
                                        <ActionButton variant={'reset'} text={'+ Add Question'} handleSubmit={() => addQuestionToPage(pageIndex)} />
                                    </div>
                                </>
                            )}
                        </div>
                    ))
                }
                <div className="flex my-2 justify-end gap-2">
                    <ActionButton variant={'reset'} text={'+ Add Bonus Page'} handleSubmit={addBonusPage} />
                    <ActionButton variant={'reset'} text={'+ Add New Page'} handleSubmit={addPage} />
                </div>
                {
                    localErrors[0]?.pageErr && (
                        <div className="text-red text-sm font-bold text-right">{localErrors[0].message}</div>
                    )
                }
            </div>

            <div className='flex justify-between mt-10'>
                <ActionButton variant={'reset'} text={'Reset'} />
                <div className='flex gap-2.5'>
                    {
                        !active &&
                        <div className='flex justify-end'>
                            <ActionButton
                                text={'Save Draft'}
                                variant={'white'}
                                handleSubmit={handleSaveDraft}
                            />
                        </div>
                    }
                    <ActionButton variant={'cancel'} text={'Cancel'} handleSubmit={() => navigate('/challenges/challenges-main/view-challenges')} />
                    <ActionButton variant={'prev'} text={'< Previous'} handleSubmit={() => {
                        setSelectedTab('challenge-information');
                        // setSelectedTab('App Display Configuration');
                    }} />
                    <ActionButton variant={'submit'} text={'Next >'} handleSubmit={handleNext} />
                </div>
            </div>
        </form >
    );
}

export default SubmissionInformation;